<template>
  <div>
    <SignIn></SignIn>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const SignIn = defineAsyncComponent(() => import("@/components/auth/SignIn"));
export default {
  components: {
    SignIn,
  },
};
</script>
